import { render, staticRenderFns } from "./TaskItemInfo.vue?vue&type=template&id=a9efd876&scoped=true&"
import script from "./TaskItemInfo.vue?vue&type=script&lang=js&"
export * from "./TaskItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemInfo.vue?vue&type=style&index=0&id=a9efd876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9efd876",
  null
  
)

export default component.exports